<script setup lang="ts">
import type { ArticleContent } from '~/models/Content/ArticleContent'
import TextBox from '~/components/article/TextBox.vue'

defineProps<{ articleContent: ArticleContent }>()
</script>

<template>
  <TextBox
    :article-content
    dashed
    shade="light"
  />
</template>
